import _ from "lodash";

import {
  Swarm,
  SwarmGetSessionRejectedError,
  WebsocketClosingError,
  WebsocketTimeoutError
} from "@lbs/swarm-client";

import { toastWrapper } from "src/common/components/toastWrapper";

interface SwarmResponse<T = any> {
  data: {
    code: number;
    data: T;
  };
}

export enum ResponseCodeEnum {
  Ok = 0,
  SessionLost = 5,
  NeedToLogin = 12,
}

const noConnectionKindErrors = [
  SwarmGetSessionRejectedError,
  WebsocketTimeoutError,
  WebsocketClosingError,
];

const showNoConnectionToast = _.throttle(() => {
  toastWrapper('error', 'Connection lost... Trying to reconnect');
}, 10000);

export const swarmRequest = async <T = any>(
  request: Record<string, any>,
  command: string = 'get'
): Promise<T | any | null> => {
  try {
    const response = await Swarm.getInstance().getData<T>(request, command) as SwarmResponse<T>;

    if (response.data.code === ResponseCodeEnum.Ok) {
      return response.data.data;
    }

    throw response.data;
  } catch (reason: any) {
    const isConnectionError = noConnectionKindErrors.some(
      (errorKind) => reason instanceof errorKind
    );

    if (isConnectionError) {
      showNoConnectionToast();
      return null;
    }
    if (reason?.code === ResponseCodeEnum.NeedToLogin) {
      return reason.data;
    }

    throw reason;
  }
};
